import { Component, QueryList, ViewChildren } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { NotEligibleComponent } from "./not-eligible/not-eligible.component";
import { DefaulterCompanyDetailComponent } from "./defaulter-company-detail/defaulter-company-detail.component";
import { ActivatedRoute, Router } from '@angular/router';
import { MediationEligibility } from './eligibility.config';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { MediationServiceModel } from '../../../../shared/models/services-request/mediation-service.model';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { Utils } from '../../../../Utils/utils';
import { DocumentServiceType, FieldValue, ServiceName, SrActionType, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ApiService } from '../../../../core/services/api.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { MEDIATION_QUIZ_QUESTIONS, QuizQuestion } from './mediation-quiz-questions';
import { UserModel } from '../../../../shared/models/loginuser.model';
import { AddCompanyComponent } from "./add-company/add-company.component";
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { FolderResponse, AllowedDocumentType } from '../../../../shared/models/documents-response.model';
import { customValidator } from '../../../../Utils/validator';
import { OptionFieldComponent } from '../../../../shared/components/controls/option-field/option-field.component';
import { TextFieldComponent } from '../../../../shared/components/controls/text-field/text-field.component';
import { MobileNumberComponent } from '../../../../shared/components/controls/mobile-number/mobile-number.component';
import { DateComponent } from '../../../../shared/components/controls/date/date.component';
import { LookupService } from '../../../../core/services/lookup.service';
import { CurrencyPipe } from '../../../../shared/pipes/currency.pipe';
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-mediation',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, NotEligibleComponent, DefaulterCompanyDetailComponent, AddCompanyComponent,
    SrSubmitSuccessModalComponent, SkeletonLoaderComponent, CurrencyPipe],
  templateUrl: './mediation.component.html',
  styleUrl: './mediation.component.scss'
})

export class MediationComponent {
  @ViewChildren(TextFieldComponent) textFields!: QueryList<TextFieldComponent>;
  @ViewChildren(OptionFieldComponent) optionFields!: QueryList<OptionFieldComponent>;
  @ViewChildren(MobileNumberComponent) mobileFields!: QueryList<MobileNumberComponent>;
  @ViewChildren(DateComponent) dateFields!: QueryList<DateComponent>;
  @ViewChildren('companyDetailComp') companyDetailComp!: QueryList<DefaulterCompanyDetailComponent>;
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  mediationRequest = new MediationServiceModel();
  documentServiceType = DocumentServiceType;
  lookupKey = LookupKey;
  form: FormGroup;
  companyForm: FormGroup;
  step: any = 1;
  totalSteps: any = 6;
  questions: QuizQuestion[] = MEDIATION_QUIZ_QUESTIONS;
  currentQuestion = 0;
  eligibility = MediationEligibility;
  agreeTermsAndCondition: boolean = false;
  termsModal: boolean = false;
  readonly mediationTerms = {
    prerequisitesHeading: 'MEDIATION.TERMS_CONTENT.PRECONDITIONS.TITLE',
    prerequisites: [
      'MEDIATION.TERMS_CONTENT.PRECONDITIONS.ITEM_1',
      'MEDIATION.TERMS_CONTENT.PRECONDITIONS.ITEM_2',
      'MEDIATION.TERMS_CONTENT.PRECONDITIONS.ITEM_3',
      'MEDIATION.TERMS_CONTENT.PRECONDITIONS.ITEM_4',
      'MEDIATION.TERMS_CONTENT.PRECONDITIONS.ITEM_5'
    ],
    acknowledgementsHeading:
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.TITLE',
    acknowledgements: [
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_1',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_2',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_3',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_4',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_5',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_6',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_7',
      'MEDIATION.TERMS_CONTENT.ACKNOWLEDGEMENTS.ITEM_8'
    ]
  } as const;
  accountId: string = "";//1-5TSHLR5
  loginUser!: UserModel;
  loginUserName: string = "";
  selectedMemberAccount: any = "";
  srDetailLoading: boolean = false;
  lang: string = "en";
  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  notEligibleReason: any = "";
  isDCMember: boolean = false;
  userCSN: string = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private translate: TranslateService,
    private sharedService: SharedService,
    private lookupService: LookupService
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.accountId = this.sharedService.getCsnAccountId('id');
    this.userCSN = this.sharedService.getCsnAccountId('csn');
    this.loginUser = this.sharedService.getUserProfile();
    this.selectedMemberAccount = this.sharedService.getPrimaryAccount();
    this.loginUserName = `${this.loginUser['First Name']} ${this.loginUser['Last Name']}`;
    this.form = this.fb.group(
      this.questions.reduce((acc, q) => {
        acc[q.key] = ['', Validators.required];
        return acc;
      }, {} as Record<string, any>)
    );

    this.companyForm = this.fb.group({
      search: [null],
      company: ['', [Validators.required]],
      pocFullName: ['', [Validators.required, Validators.maxLength(100)]],
      pocMobile: ['', [Validators.required, customValidator('uaeMobile'), Validators.maxLength(15)]],
      pocEmail: ['', [Validators.required, customValidator('email'), Validators.maxLength(100)]],
      pocMobileCC: [null, [Validators.required]],
      pocPhone: ['', [customValidator('uaePhoneNumber'), Validators.maxLength(15)]],
      pocCountry: [null, [Validators.required]],
      pocPhoneCC: [null],
      pocCity: ['', [Validators.required, customValidator('safeText')]],
      type: [null, Validators.required],
      details: ['', [Validators.required, Validators.maxLength(2000), customValidator('safeText')]],
      currency: [{ value: "AED", disabled: true }, [Validators.required, Validators.maxLength(30)]],
      amount: ['', [Validators.required, Validators.maxLength(15)]],
      dateMode: [false],
      dateFrom: this.fb.group({
        day: [null, Validators.required],
        month: [null, Validators.required],
        year: [null, Validators.required],
      }),
      dateTo: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      request: ['', [Validators.maxLength(200), customValidator('safeText')]],
      paymentMethod: [null]
    });

    if (!this.userCSN) {
      this.sharedService.toastMessage('INFO', 'NO_CSN_NUMBER', 'info');
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }

    this.sharedService.getSrNumber(this.route).subscribe(srNumber => {
      if (srNumber) {
        this.srNumber = srNumber;
        this.step = 5;
        this.getSRDetail();
      }
    });

    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber;
      this.getSRDetail();
    }
    this.getMediationFees();
    this.getMediationFees(true);

    this.getCurrencyList();
    this.openFolder();
  }

  openTermsModal(event?: Event) {
    event?.preventDefault();
    this.termsModal = true;
  }

  closeTermsModal() {
    this.termsModal = false;
  }

  addCompanyModal: boolean = false;
  companyDetail: any = ""
  companyFormData: any = ""
  // This method is used to open add company form using company data
  openAddCompanyForm(companyData: any) {
    if (companyData && companyData.data) {
      this.companyDetail = companyData.data;
    }
    this.addCompanyModal = true;
  }

  // This method is used to submit company deatil using company form data
  submitCompanyDeatil(companyFormData: any) {
    this.companyFormData = companyFormData;
  }

  //calculate form progress
  // This method is used to calculate form progress
  get formProgress() {
    if (this.step <= 3) {
      return 0;
    } else {
      if (this.companyForm.disabled || this.form.disabled) {
        return 100;
      }
      if (!this.companyForm.invalid) {
        if (this.step == this.totalSteps && !this.checkRequiredDocuments()) {
          return 100;
        }
      }
      return Utils.calculateFormProgress(this.step, this.totalSteps);
    }
  }


  // This method is used to move to the next question using control name
  nextQuestion(controlName: any) {
    let userType = this.sharedService.getPrimaryAccount()['Account Type Code'];
    if (this.form.controls[controlName].valid && this.form.controls[controlName].value) {

      if (this.questions[this.currentQuestion]) {
        let question: any = this.questions[this.currentQuestion];
        question['answer'] = this.form.controls[controlName].value;
        if (question['key'] == 'dc-member') {
          this.isDCMember = this.form.controls[controlName].value == 'Yes' ? true : false;
        }
        if (userType != UserType.MEMBER && question['key'] == 'dc-member') {
          if (question['key'] == 'dc-member' && this.form.controls[controlName].value != 'Yes') {
            this.step = 3;
            this.notEligibleReason = "nonMember";
            return
          }
        }

        if (question['key'] == 'prior-action') {
          if (this.form.controls[controlName].value != 'None of the above') {
            this.step = 3;
            this.notEligibleReason = "underAuthority";
            return;
          }
        }

        if (question['key'] == 'non-commercial' && this.form.controls[controlName].value == 'Yes') {
          this.step = 3;
          this.notEligibleReason = "nonCommercial";
          return
        }
      }

      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
      }
    }
  }
  // This method is used to return to the previous question
  prevQuestion() {
    if (this.currentQuestion > 0) {
      this.currentQuestion--;
    }
  }

  // This method is used to advance on option selection
  onOptionSelect(controlName: string) {
    if (this.currentQuestion === this.questions.length - 1) {
      this.finish(controlName);
      return;
    }
    this.nextQuestion(controlName);
  }

  // In the last question answer move to next
  finish(controlName: string) {
    if (this.form.valid) {
      let question: any = this.questions[this.currentQuestion];
      question['answer'] = this.form.controls[controlName].value;
      if (question['key'] == 'non-commercial' && this.form.controls[controlName].value == 'Yes') {
        this.step = 3;
        this.notEligibleReason = "nonCommercial";
        return
      }
      this.step = 4;
    } else {
      this.form.markAllAsTouched();
    }
  }

  currencyList: any = [];
  // This method is used to get currency list
  getCurrencyList() {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Currency List WF",
        "CurrencyCode": ""
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration, ApiEndPoints.GET_CURRENCY_LIST,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response.SiebelMessage?.Currency) {

          let list = Utils.checkIsArray(response.SiebelMessage?.Currency);
          // Keep only AED
          list = list.filter((item: any) => item["Currency Code"] === "AED");
          this.currencyList = list.map((item: any) => ({
            ...item,
            Name: item.Name,
            Value: item["Currency Code"]
          }));
        }
      }
    })
  }

  MedRegFeeMem: string = "0";
  MedRegFeeNonMem: string = "0";
  MedAdmFeeMemP: string = "0";
  MedAdmFeeMemMax: string = "0";
  MedAdmFeeMemMin: string = "0";
  MedAdmFeeNonMemP: string = "0";
  MedAdmFeeNonMemMax: string = "0";
  MedAdmFeeNonMemMin: string = "0";

  getMediationFees(isAdminFee: boolean = false) {
    if (this.srNumber) {
      return;
    }
    this.lookupService
      .post(LookupKey.LOOKUP_URL, {
        ProcessName: "DC Get List Of Values WF",
        Type: isAdminFee ? LookupKey.DC_MEDIATION_ADMINISTRATIVE_FE : LookupKey.DC_MEDIATION_REGISTRATION_FEE,
        ParentValue: ''
      })
      .subscribe({
        next: (result: any) => {
          if (result.SiebelMessage?.['List Of Values'] && !result["Error Message"]) {
            if (isAdminFee) {
              let administrativeFees = result.SiebelMessage['List Of Values'];
              administrativeFees?.map((f: any) => {
                if (f.Name == 'Member %') {
                  this.MedAdmFeeMemP = f.Value;
                }
                if (f.Name == 'Member Max') {
                  this.MedAdmFeeMemMax = f.Value;
                }
                if (f.Name == 'Member Max Min') {
                  this.MedAdmFeeMemMin = f.Value;
                }


                if (f.Name == 'Non Member %') {
                  this.MedAdmFeeNonMemP = f.Value;
                }
                if (f.Name == 'Non Member Max') {
                  this.MedAdmFeeNonMemMax = f.Value;
                }
                if (f.Name == 'Non Member Min') {
                  this.MedAdmFeeNonMemMin = f.Value;
                }
              })
            } else {
              let registrationFees = result.SiebelMessage['List Of Values'];
              registrationFees?.map((f: any) => {
                if (f.Name == 'Non Member') {
                  this.MedRegFeeNonMem = f.Value;
                }
                if (f.Name == UserType.MEMBER) {
                  this.MedRegFeeMem = f.Value;
                }
              })
            }
          }
        }, error: () => {

        }
      })
  }


  // This method is used to proced to fill application
  procedToFillApplication() {
    if (this.agreeTermsAndCondition == true) {
      this.step = 5;
      // this.submitFormData({}, SrActionType.DRAFT);
    } else {
      return
    }
  }

  // on form submit with fields value and action type
  // This method is used to submit data using form fields
  submitData(formFields: any) {
    this.submitFormData(formFields.formData, formFields.actionType);
  }

  //get folder id and attachments
  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];

  private readonly supportingDocumentTypeNamesSet = new Set<string>([
    'quotation',
    'lpos',
    'invoices',
    'contract/agreement',
    'delivery notes',
    'bill of lading',
    'statement of account',
    'letter of credit',
    'correspondences'
  ]);

  // This method is used to open folder
  openFolder() {
    let isLabels = !this.srNumber; // true if srNumber is empty
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.MEDIATION, isLabels)
      .subscribe({
        // This method is used to handle the next callback using response
        next: (response: any) => {
          if (response.success) {
            // If SR exists → response.data, otherwise → response
            this.srFolder = response.data ? response.data : response;
            this.mainFromSectionDocs = this.srFolder.allowedDocumentTypes?.filter((d: any) => !d.forUISection);
          } else {
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        },
        // This method is used to handle the error callback using err
        error: () => {
          this.sharedService.toastMessage("error", 'TECHNICAL_ERROR', 'error');
        }
      });
  }
  formSubmitLoader: boolean = false;
  srNumber: string = "";
  srId: any = "";
  isSaved: boolean = true;
  successModal: boolean = false;
  showActions: boolean = true;
  srDetails: any = "";
  // This method is used to get sr detail
  getSRDetail() {
    this.srDetailLoading = true;
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get SR Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.MEDIATION,
        "SR Number": this.srNumber,
        "IOName": SrIOName.MEDIATION
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_DETAIL,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.srDetailLoading = false;
        if (response?.SiebelMessage && response?.SiebelMessage["DC Mem SR"]) {
          let serviceRequest = response?.SiebelMessage["DC Mem SR"];
          this.srNumber = serviceRequest["SR Number"];
          this.accountId = serviceRequest["Account Id"];
          this.srId = serviceRequest["SR Id"];
          this.srDetails = serviceRequest;

          if (serviceRequest["DC Respondant Name"]) {
            this.companyFormData = {
              nameEnglish: serviceRequest["DC Respondant Name"],
              nameArabic: serviceRequest["DC Respondent Name Ara"],
              country: serviceRequest["DC Respondant Country"],
              email: serviceRequest["DC MRM CEO Email"],
              phone: serviceRequest["DC Respondant Telephone Number"] ? Utils.parseMobile(serviceRequest["DC Respondant Telephone Number"], 'number') : "",
              countryCode: serviceRequest["DC Respondant Telephone Number"] ? Utils.parseMobile(serviceRequest["DC Respondant Telephone Number"], 'cc') : "",
              city: serviceRequest["DC Respondant City"],
              address: serviceRequest["DC Respondant Postal Address"],
              poBox: serviceRequest["DC Respondant PO Box Number"],
              respondentMemberNumber: serviceRequest["DC Respondent Member Name"]
            }
            if (serviceRequest["DC Respondent Member Name"]) {
              this.isDCMember = true;
            }
            this.step = 6;
          }
          if (this.sharedService.enableNotesOption(serviceRequest["Status"])) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }
          if (serviceRequest["Status"] != SrStatus.Draft && serviceRequest["Status"] != SrStatus.AwaitingClarification) {
            this.showActions = false;
            this.form.disable(); // disables all fields in the form
          }
        }

      },
      // This method is used to handle the error callback
      error: () => {
        this.srDetailLoading = false;
      }
    })
  }

  // This method is used to save and close
  saveAndClose() {
    this.submitFormData(this.companyForm.value, SrActionType.SAVE);
  }
  allFields: any = [];
  // This method is used to move to the next step
  nextStep() {
    if (this.step >= 5) {
      this.companyForm.get('paymentMethod')?.setValidators([Validators.required]);
      this.companyForm.get('paymentMethod')?.updateValueAndValidity();
      if (this.srNumber == "") {
        this.submitFormData(this.companyForm.value, SrActionType.DRAFT);
      }
      this.step = 6;
    }
    let hasInvalid = false;
    this.companyDetailComp.forEach((child: DefaulterCompanyDetailComponent) => {
      if (child.checkInvalidFields()) {
        hasInvalid = true;
      }
      if (child.companyContactError) {
        hasInvalid = true;
      }
    });

    if (hasInvalid) {
      return;
    }
    if (this.companyForm.invalid) {
      const invalidControls = Utils.getInvalidControls(this.form);
      this.companyForm.markAllAsTouched();
      this.companyForm.updateValueAndValidity();
      console.warn('Invalid controls:', invalidControls);
      return;
    }
    if (this.step == 5) {
      this.submitFormData(this.companyForm.value, SrActionType.DRAFT);
    }

    if (this.step >= 6) {
      this.submitFormData(this.companyForm.value, SrActionType.SUBMIT);
    }
    this.step = 6;
  }
  // This method is used to normalize doc type using value
  private normalizeDocType(value?: string | null): string {
    return (value ?? '')
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    this.errorMsg = "";
    // If there are no docs to check, nothing is missing
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];

    // ViewChildren not ready or not fully rendered yet - defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }
    let hasMissing = false;
    const relevantDocNames = this.mainFromSectionDocs
      .map(doc => this.normalizeDocType(doc?.nameEn))
      .filter(name => !!name && this.supportingDocumentTypeNamesSet.has(name));

    if (relevantDocNames.length > 0) {
      const relevantDocNameSet = new Set(relevantDocNames);
      const documents = this.srFolder?.documents ?? [];
      const hasSupportingDocUploaded = documents.some((doc: any) =>
        relevantDocNameSet.has(this.normalizeDocType(doc?.documentType))
      );

      if (!hasSupportingDocUploaded) {
        this.errorMsg = this.translate.instant('MEDIATION.FORM.UPLOAD_AT_LEAST_ONE_DOCUMENT');
        hasMissing = true;
      } else {
        hasMissing = false;
      }
    }


    // for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
    //   const doc = this.mainFromSectionDocs[index];
    //   const cmp = fileCmps[index];
    //   // Safety guard; should not happen due to length check above
    //   if (!cmp) continue;

    //   if (typeof cmp.checkMissing === 'function' && cmp.checkMissing(doc?.mandatory)) {
    //     hasMissing = true;
    //   }
    // }
    return hasMissing;
  }
  errorMsg: any = "";
  technicalErrorMsg: boolean = false;
  // This method is used to submit form data using form fields and action type
  submitFormData(formFields: any, actionType: string) {
    this.errorMsg = "";
    this.technicalErrorMsg = false;
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    const defaultShowActions = this.showActions;
    const currentErrorMsg = this.errorMsg;
    const restoreFormState = () => {
      this.showActions = defaultShowActions;
      this.companyForm.enable({ emitEvent: false });
      this.companyForm.get('currency')?.disable({ emitEvent: false });
      this.form.enable({ emitEvent: false });
      this.formSubmitLoader = false;
      this.errorMsg = currentErrorMsg;
    };

    if (Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      return;
    }

    if (isActionSubmit && this.checkRequiredDocuments()) {
      return;
    }

    this.mediationRequest.body.SiebelMessage.MessageId = Utils.generateUniqueId();
    let dcMemSR: any = {
      "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
      "DC Payment Method": formFields.paymentMethod ? formFields.paymentMethod : "",
      "SR Type": ServiceName.MEDIATION_SERVICES,
      "SR Sub Type": ServiceName.MEDIATION,
      "DC Person Incharge": formFields.pocFullName ? formFields.pocFullName : "",
      "DC Person Incharge Mobile": formFields.pocMobile ? `${formFields.pocMobileCC}${formFields.pocMobile}` : "",
      "DC Person Incharge Email Address": formFields.pocEmail ? formFields.pocEmail : "",
      "DC Person Incharge Telephone Number": formFields.pocPhone ? `${formFields.pocPhoneCC}${formFields.pocPhone}` : "",

      "DC Person Incharge Country": formFields.pocCountry ? formFields.pocCountry : "",
      "DC Person Incharge City": formFields.pocCity ? formFields.pocCity : "",

      "DC Respondant Name": formFields.company?.nameEnglish ? formFields.company.nameEnglish : "",
      "DC Respondent Name Ara": formFields.company?.nameArabic ? formFields.company.nameArabic : "",
      "DC Respondant Country": formFields.company?.country ? formFields.company.country : "",
      "DC Respondant City": formFields.company?.city ? formFields.company.city : "",
      "DC Respondant Telephone Number": formFields.company?.phone ?
        `${formFields.company.countryCode}${formFields.company.phone}` : "",
      "DC Respondant PO Box Number": formFields.company?.poBox ? formFields.company.poBox : "",
      "DC Respondant Postal Address": formFields.company?.address ? formFields.company.address : "",

      "DC Nature Of Dispute": formFields.type ? formFields.type : "",//"Compensation",
      "DC Dispute In Brief Flag": "Y", //formFields.details ?? "", //"Y",
      "DC Invoice Amount": formFields.amount ? formFields.amount : formFields.amount,
      "DC Complainant Request": formFields.request ? formFields.request : "",
      "Currency": "AED",//formFields.currency ? formFields.currency : "",
      "DC MRM CEO Email": formFields.company?.email ? formFields.company.email : "",

      "Description": formFields.details ?? "",
      "DC Member Name(English)": this.selectedMemberAccount?.["DC Name English"],
      "DC Member Name(Arabic)": this.selectedMemberAccount?.["DC Name Arabic"],
      "DC Transaction From Date": formFields?.dateFrom && (formFields.dateFrom?.day) ?
        `${formFields.dateFrom.month}/${formFields.dateFrom.day}/${formFields.dateFrom.year}` : '',
      "DC Transaction To Date": formFields.dateMode ? (formFields?.dateTo && (formFields.dateTo?.day) ?
        `${formFields.dateTo.month}/${formFields.dateTo.day}/${formFields.dateTo.year}` : '') : "",
      "Account Id": this.accountId,
      "SR Number": this.srNumber ?? "",
      "DC ATA Consent": "Y",
      "DC Respondent Member Name": formFields.company?.respondentMemberNumber ? formFields.company.respondentMemberNumber : "",
    }
    this.mediationRequest.body.DCMethod = isActionSubmit ? 'SUBMIT' : 'SAVEASDRAFT';
    this.mediationRequest.body.SiebelMessage["ListOfDCMemSRIO"]["DC Mem SR"] = dcMemSR;
    if (!isActionDraft) {
      this.showActions = false;
      this.companyForm.disable({ emitEvent: false });
      this.form.disable({ emitEvent: false });
    }
    this.formSubmitLoader = isActionDraft ? false : true;
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.CREATE_UPDATE_SR,
      this.mediationRequest
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if ((response['Error Code'] == "" || response['Error Code'] == "DC-VAL-ERR")
          && response["Error Message"] == null || response["Error Message"] == ""
          && response["SR Number"]) {
          if (!isActionDraft) {
            restoreFormState();
          }

          this.isSaved = true;
          this.srId = response['SRId'];
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["SR Number"];
              sessionStorage.setItem("srNumber", response["SR Number"]);
              this.openFolder();
            } else {
              this.srNumber = response["SR Number"];
              sessionStorage.setItem("srNumber", response["SR Number"]);
              if (isActionSave) {
                this.successModal = true;
              }
            }
          } else {
            //set sr detail for success page to get ioname
            this.srNumber = response["SR Number"];
            let lang: any = this.sharedService.getCurrentLang();

            const { service, serviceAr } = Utils.getServiceLabels(ServiceName.MEDIATION, lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              service: ServiceName.MEDIATION,
              IOName: SrIOName.MEDIATION,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step
            }
            this.sharedService.setSrResponse(srDetailObj);

            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }
        } else {
          this.isSaved = true;
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != "") {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
          if (!isActionDraft) {
            restoreFormState();
          }
        }
      },
      // This method is used to handle the error callback
      error: () => {
        this.technicalErrorMsg = true;
        this.isSaved = true;
        if (!isActionDraft) {
          restoreFormState();
        }
      }
    })
  }

  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {
    let documents = Utils.checkIsArray(document);
    Utils.setControlValidityBasedOnDocument(this.form, documentField, documents);
  }
  // This method is used to handle payment method change using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    this.noAdvancePaymentBalance = false;
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }
  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
  }
}

